import UnlimitedIcon from '@material-ui/icons/AllInclusive';
import classNames from 'classnames';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/usageStyle';
import { makeStyles } from '@material-ui/core';
import { translate } from 'components/Translation';
import { HeadingSBold, BodyS, Caption } from 'components/Typography/Typography';
import CustomLinearProgress from 'components/CustomLinearProgress/CustomLinearProgress';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISubbundleLeftProps {
	header: string;
	subheader: string;
	data: any;
	warning?: boolean;
	message?: string;
}

const SubbundleLeft = ({ header, subheader, data, warning, message }: ISubbundleLeftProps) => {
	const classes = useStyles();

	const usage = (
		<ConditionalRender
			show={data.unlimited}
			onTrue={() => <UnlimitedIcon className={classes.unlimitedSubIcon} />}
			onFalse={() => (
				<>
					<div>
						<HeadingSBold inline>{data.balance.value}</HeadingSBold>
						<p
							className={classNames(classes.bundleLeft, {
								[classes.warningMessage]: warning,
							})}
						>
							{translate('numbers.usage.bundleLeft', data.balance.unit)}
						</p>
					</div>
					<div>
						<HeadingSBold color="disabled-light">
							<>
								{data.totalPackageSize.value} {data.totalPackageSize.unit}
							</>
						</HeadingSBold>
					</div>
				</>
			)}
		/>
	);

	return (
		<div className={classes.bundleContainer}>
			<HeadingSBold disableMargin>{header}</HeadingSBold>
			<BodyS color="secondary-light">{subheader}</BodyS>

			<div className={classes.progressContainer}>
				{!data.unlimited && (
					<CustomLinearProgress
						variant="determinate"
						color={warning ? 'danger' : 'primary'}
						value={100 - data.usedPercentage}
						className={classes.linearBar}
					/>
				)}
				<div className={classes.usageContainer}>{usage}</div>
				<ConditionalRender
					show={!!message}
					onTrue={() => (
						<Caption color={warning ? 'danger' : 'disabled-light'} disableMargin>
							{message}
						</Caption>
					)}
				/>
			</div>
		</div>
	);
};

export default SubbundleLeft;
